import styles from "../../dashboard.module.scss";

export const Arrow = () => {
  return (
    <div className={styles.dashboardEmptyStateArrow} aria-hidden="true">
      <svg
        className={styles.dashboardEmptyStateArrowSvg}
        viewBox="0 0 312 350"
        preserveAspectRatio="xMaxYMin meet"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden
      >
        <path
          d="M1.64314 345.351C0.818496 345.272 0.085901 345.877 0.00684559 346.701C-0.07221 347.526 0.532211 348.258 1.35686 348.337L1.5 346.844L1.64314 345.351ZM297.396 0.18087C296.667 -0.213251 295.757 0.0579548 295.363 0.786625L288.94 12.661C288.546 13.3897 288.817 14.2999 289.546 14.694C290.275 15.0881 291.185 14.8169 291.579 14.0882L297.288 3.53324L307.843 9.24219C308.572 9.63631 309.482 9.36511 309.876 8.63644C310.27 7.90777 309.999 6.99756 309.27 6.60344L297.396 0.18087ZM1.5 346.844L1.35686 348.337C104.802 358.254 194.409 323.19 250.463 259.687C306.532 196.166 328.891 104.344 298.12 1.07191L296.682 1.50024L295.245 1.92858C325.746 104.296 303.54 195.023 248.214 257.702C192.871 320.4 104.25 355.188 1.64314 345.351L1.5 346.844Z"
          fill="#DCE0E6"
        />
      </svg>
    </div>
  );
};
